<mat-toolbar class="desktop-toolbar">
    <mat-toolbar-row>
        <div class="toolbar-info">
            <div class="data-segment" style="padding:0">
                <button mat-icon-button (click)="onToggleSidebar()">
          <mat-icon>menu</mat-icon>
        </button>
            </div>
            <div class="data-segment">
                <mat-icon>today</mat-icon>
                <span class="time-zone">{{initials?.profile?.timezone_data?.code}}</span>
            </div>
        </div>
        <div class="toolbar-action">
            <!-- <button mat-button [matMenuTriggerFor]="miniBasket"
        *ngIf="!!miniBasketListCount && currentUrl !='/basket/shipping'">
        <mat-icon [matBadge]="miniBasketListCount" matBadgeColor="accent">shopping_cart</mat-icon>
      </button> -->

      <button mat-button *ngIf="hasPaymentAccess" [matMenuTriggerFor]="paymentCategories">
        <mat-icon>add</mat-icon>
        <span>Payment</span>
      </button>

            <!-- <mat-menu class='mini-basket-wrap' #miniBasket="matMenu">
        <app-mini-basket (itemRemoved)="onRemovedItem($event)" [items]="lists$ | async"></app-mini-basket>
      </mat-menu> -->
            <button mat-button [matMenuTriggerFor]="userProfile" class="action-btn">
        <img class="avatar" *ngIf="!userAvatar" src="assets/images/avatar.png" alt="avatar">
        <img class="avatar" *ngIf="userAvatar" [src]="userAvatar" alt="avatar">
        <div class="account-owner">
          <span>{{ displayName | slice:0:10}}</span>
          <span *ngIf="displayName.length > 10">...</span>
          <mat-icon class="icon" aria-hidden="false" aria-label="user-profile">keyboard_arrow_down</mat-icon>
        </div>
      </button>
      <mat-menu #userProfile="matMenu">
        <button mat-menu-item *ngIf="availableMerchants.length > 1" (click)="showMerchantsDialog()">
          <mat-icon>workspaces</mat-icon>
          Switch Workspace
        </button>
        <button mat-menu-item [routerLink]="['/dashboard/profile']">
          <mat-icon>person</mat-icon>
          <span>Profile</span>
        </button>
        <!-- <button mat-menu-item *ngIf="hasDocumentAccess() && !isSubUser" [routerLink]="['/dashboard/documents']">
          <mat-icon>description</mat-icon>
          <span>Documents</span>
        </button> -->
        <button *ngIf="!isSubUser" mat-menu-item [routerLink]="['/user/price-list']">
          <mat-icon>money</mat-icon>
          <span>My Price List</span>
        </button>
        <button mat-menu-item [routerLink]="['/reports/activity-logs']">
          <mat-icon>punch_clock</mat-icon>
          <span>Activity Log</span>
        </button>
        <button mat-menu-item (click)="onLogout()">
          <mat-icon>exit_to_app</mat-icon>
          <span>Log Out</span>
        </button>
            </mat-menu>
            <button *ngIf="initials?.profile?.balances.length" mat-button [matMenuTriggerFor]="creditCard" class="action-btn">
        <mat-icon>credit_card</mat-icon>
        <div>
          <span>Wallet</span>
          <mat-icon class="icon" aria-hidden="false" aria-label="credit">keyboard_arrow_down</mat-icon>
        </div>
      </button>
      <button mat-button [matMenuTriggerFor]="inbox" class="action-btn">
        <mat-icon>move_to_inbox</mat-icon>
        <div>
          <span>Inbox</span>
          <mat-icon class="icon" aria-hidden="false" aria-label="credit">keyboard_arrow_down</mat-icon>
        </div>
      </button>

      <div class="data-segment" *ngIf="!initials.profile?.sales_manager && initials.profile?.reseller || isAdmin">
        <span>{{initials?.profile?.role.role_name}}</span>
        <span class="seprator">-</span>
        <span>{{initials?.profile?.office}}</span>
      </div>
      <div class="data-segment sales-manager" (click)="openSalesManagerDialog()"
        *ngIf="initials.profile?.sales_manager && initials.profile?.admin && !initials.profile?.reseller">
        <p>
          <mat-icon> info</mat-icon>
          <span>Sales Manager Info</span>
        </p>
      </div>
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<mat-toolbar class="mobile-toolbar">
    <mat-toolbar-row class="toolbar-row">
        <button mat-icon-button color="primary" (click)="onToggleSidebar()">
      <mat-icon>menu</mat-icon>
    </button>
    <img [src]="environmentConfig.logoPrintSrc" width="64px" class="logo" [alt]="environmentConfig.imageAlt">
    <div>
      <!-- <button class="mobile-basket" mat-button [matMenuTriggerFor]="miniBasket"
        *ngIf="!!miniBasketListCount && currentUrl !='/basket/shipping'">
        <mat-icon [matBadge]="miniBasketListCount" matBadgeColor="accent">shopping_cart</mat-icon>
      </button> -->
      <button mat-button class="avatar-icon" [matMenuTriggerFor]="userProfile">
        <img src="assets/images/avatar-2x.png" width="24px" height="auto">
        <mat-icon color="primary">arrow_drop_down</mat-icon>
      </button>
        </div>
    </mat-toolbar-row>
    <mat-toolbar-row>
        <div class="toolbar-action">
            <div class="data-segment">
                <mat-icon>today</mat-icon>
                <span class="time-zone">{{initials?.profile?.timezone_data?.code}}</span>
            </div>
            <button *ngIf="initials?.profile?.balances.length" mat-button [matMenuTriggerFor]="creditCard" class="action-btn wallet-btn">
        <mat-icon>credit_card</mat-icon>
        <div>
          <span>Wallet</span>
          <mat-icon class="icon" aria-hidden="false" aria-label="credit">keyboard_arrow_down</mat-icon>
        </div>
      </button>
      <button mat-button [matMenuTriggerFor]="inbox" class="action-btn" *ngIf="!isSubUser">
        <mat-icon>move_to_inbox</mat-icon>
        <div>
          <span>Inbox</span>
          <mat-icon class="icon" aria-hidden="false" aria-label="credit">keyboard_arrow_down</mat-icon>
        </div>
      </button>
      <button mat-button *ngIf="hasPaymentAccess" [matMenuTriggerFor]="paymentCategories" >
        <mat-icon>add</mat-icon>
        <span>Payment</span>
      </button>

        </div>
    </mat-toolbar-row>
</mat-toolbar>

<mat-menu #inbox="matMenu">
  <div *ngIf="outgoingMessageList?.results" class="log-container">
    <div *ngFor="let message of outgoingMessageList?.results">
      <div class="message logs" (click)="showMessageLog(message)"
        *ngIf="message.notification_event_detail?.content || message.notification_event_detail?.template_detail?.content || message.subject">
        <p class="subject">{{message.subject}}</p>
        <!-- <p class="content"
          [innerHtml]="message.notification_event_detail?.content || message.notification_event_detail?.template_detail?.content">
        </p> -->
      </div>
    </div>
    <div *ngIf="!outgoingMessageList?.results.length">
      <p>
        No notifications
      </p>
    </div>
    <button *ngIf="outgoingMessageList?.results.length > 5" mat-button color="primary"
      [routerLink]="['/notifications/outgoing-message-log']" class="full-width">Show
      More</button>
  </div>
</mat-menu>

<mat-menu #creditCard="matMenu">
  <button mat-menu-item *ngFor="let balance of initials?.profile?.balances" class="account-credits"
    [routerLink]="['/user', 'wallet']" [queryParams]="{wallet: balance.currency.id}" [disabled]="!canViewWalletTransactions">
    <span>{{balance.currency.symbol}}{{balance.balance}}</span>
    <span>{{balance.currency.currency}}</span>
  </button>
</mat-menu>

<mat-menu #paymentCategories="matMenu">
    <ng-container *ngIf="paymentCategoryList?.length">
      <button mat-menu-item *ngFor="let category of paymentCategoryList" class="account-credits" [routerLink]="['/online-payments/add']" [queryParams]="{id: category.category}"
    >
    {{category.category_text}}
  </button>
    </ng-container>
</mat-menu>
<!-- <mat-menu class='mini-basket-wrap' #miniBasket="matMenu">
  <app-mini-basket (itemRemoved)="onRemovedItem($event)" [items]="lists$ | async"></app-mini-basket>
</mat-menu> -->

<ng-template #salesManagersDialog>
    <h3 class="sales-manager-title">Sales Manager Details</h3>
    <ul class="sales-manager-details">
        <li>
            <p>Name: </p>
            <p class="dashed"></p>
            <p>{{initials?.profile?.sales_manager.name || '-'}}</p>
        </li>
        <li>
            <p>Email: </p>
            <p class="dashed"></p>
            <p>{{initials?.profile?.sales_manager.email || '-'}}</p>
        </li>
        <li>
            <p>Phone Number: </p>
            <p class="dashed"></p>
            <p>{{initials?.profile?.sales_manager.phone || '-'}}</p>
        </li>
    </ul>
</ng-template>

<ng-template #outgoingMessageDetail>
  <div class="align-right">
    <mat-icon mat-dialog-close>close</mat-icon>
  </div>

  <div class="message-info" *ngIf="messageDetail">
    <p class="date">{{messageDetail.created_time | date:'mediumDate'}}</p>
    <p class="subject">{{messageDetail.subject}}</p>
    <!-- <p class="title">{{messageDetail.notification_event_detail?.title}}</p> -->
    <div 
      [innerHtml]="messageDetail?.rendered_content | safeHtml">
    </div>
    <!-- <p class="title">{{messageDetail.notification_event_detail?.template_detail?.title}}</p> -->
    <!-- <p [innerHtml]="messageDetail.notification_event_detail?.template_detail?.content"></p> -->
  </div>

</ng-template>

<ng-template #myMerchantListDialog let-data>
  <div class="merchant-list-wrapper">
    <div class="merchant-item" *ngFor="let merchant of data" (click)="updateCurrentMerchant(merchant.id)">
      <div class="logo">
        <img src="{{merchant.company_logo || '/assets/images/avatar.png'}}" />
      </div>
      <p class="name">
        {{ merchant.company_name }}
      </p>
    </div>
  </div>
</ng-template>